export default () => ({
  name: '',
  email: '',
  phone: '',
  paternalName: '',
  maternalName: '',
});
